import React from 'react';
import PropTypes from 'prop-types';
import ListCard from '../../../../_shared/components/ListCard';
import Wrapper from './Styles';
import Content from './Content';
import useFootersPaymentsOnHold from './Footers';
import { ListVariant } from '../../../../_shared/types/trade';

const defaultProps = {
  trade: {},
  onClickDocumentOwning: () => {},
  onClickDocumentUpload: () => {}
};

const propTypes = {
  trade: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    trim: PropTypes.string,
    make: PropTypes.string,
    model: PropTypes.string,
    vin: PropTypes.string,
    topBid: PropTypes.number.isRequired,
    bidPlacedTime: PropTypes.string,
    thumbnailUrl: PropTypes.string,
    year: PropTypes.number,
    onHoldStatuses: PropTypes.arrayOf(PropTypes.object)
  }),
  onClickDocumentOwning: PropTypes.func,
  onClickDocumentUpload: PropTypes.func
};

const PaymentsOnHoldListItem = ({
  trade,
  onClickDocumentOwning,
  onClickDocumentUpload,
  handleNavigateToTradeUri
}) => {
  const footers = useFootersPaymentsOnHold({
    trade,
    onClickDocumentOwning,
    onClickDocumentUpload
  });

  if (!trade) {
    return null;
  }
  return (
    <Wrapper data-testid={`payments-on-hold-list-item-${trade?.id}`}>
      <ListCard
        trade={trade}
        content={<Content trade={trade} />}
        cardFooters={footers}
        thumbnailUrl={trade.thumbnailUrl}
        thumbnailWidth={147}
        thumbnailHeight={127}
        redirectLink={
          trade?.isEtrTrade ? `/stocks/${trade?.id}/vdp` : `/trade/${trade?.id}`
        }
        handleNavigateToTradeUri={handleNavigateToTradeUri}
        testId={`payments-on-hold-list-card-${trade?.id}`}
        kebabPosition="top"
        variant={ListVariant.PAYMENTS_ON_HOLD}
      />
    </Wrapper>
  );
};

PaymentsOnHoldListItem.defaultProps = defaultProps;
PaymentsOnHoldListItem.propTypes = propTypes;

export default PaymentsOnHoldListItem;
